import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpStatusCode, ResponseModel } from 'src/app/Shared/model/response.model';
import { ApiDataService } from 'src/app/Shared/services/apidata.service';
import { AppService } from 'src/app/Shared/services/app.service';
import { GetSetService } from 'src/app/Shared/services/getset.serverce';
import { ToastService } from 'src/app/Shared/services/toast.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Messagetype } from 'src/app/Shared/model/model/enum';
import { ILogin } from 'src/app/Shared/model/model/login.model';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  loginForm!: FormGroup
  submitted = false;
  isForgetOtpSent = false;
  forgetOTPForm: FormGroup;
  OTPForm : FormGroup;
  otpform : FormGroup;
  hide = true;
  otp = '';
  isShowLoginForm = true;
  isForgetFormShow = false;
  showverifyOtpFormLogin = false;
  constructor(
    public formBuilder: FormBuilder,
    private apiDataService: ApiDataService,
    private appService: AppService,
    private getSetService: GetSetService,
    private toastService: ToastService,
    private router: Router,
    private _snackBar: MatSnackBar,

  ) {

    this.forgetOTPForm = this.formBuilder.group({
      username: ['', [Validators.required]],
      // newPassword: ['', [Validators.required]],
      newPassword: ['', [Validators.required, Validators.pattern(
        /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{6,})/
      ),]]
    });

    this.OTPForm = this.formBuilder.group({
      input1: ['', [Validators.required, Validators.pattern('[0-9]{1}')]],
      input2: ['', [Validators.required, Validators.pattern('[0-9]{1}')]],
      input3: ['', [Validators.required, Validators.pattern('[0-9]{1}')]],
      input4: ['', [Validators.required, Validators.pattern('[0-9]{1}')]],
    });

    this.otpform = this.formBuilder.group({
      otpinput: ['', Validators.required],
    });

  }

  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      userName: ['',[Validators.required]],
      password: ['', [Validators.required]]
    });

  }
  public onLoginFormSubmit(): void {
    this.submitted = true;
    this.loginForm?.controls.password.setValidators([Validators.required]);
    this.loginForm?.controls.password.updateValueAndValidity();
    if (this.loginForm?.valid) {
      const loginInfo: ILogin = {
        userName: this.loginForm.value.userName,
        password: this.loginForm.value.password,
      };
      const url = `User/login`;
      this.apiDataService
        .postData(url, loginInfo)
        .subscribe((response: ResponseModel<any>) => {
          if (response.status === HttpStatusCode.OK) {
            this.getSetService.SetUser(response.data);
            this.appService.setCurrentUserInfo(response.data);

            // this.toastService.showToast(
            //   Messagetype.sucess,
            //   '',
            //   `${response.statusMessage} `
            // );
            this.appService.setUserLogin(true);
            this.router.navigateByUrl(`home`);
          }
          else if (response.status === HttpStatusCode.BAD_REQUEST) {
            this.toastService.showToast(
              Messagetype.fail,
              '',
              `${response.statusMessage}`
            );
          }
        });
    }
  }

    // ----------------------------------- otp for forget ----------------------
    public getOtpForForget() {

        this.OTPForm.controls.input1.reset();
        this.OTPForm.controls.input2.reset();
        this.OTPForm.controls.input3.reset();
        this.OTPForm.controls.input4.reset();

      const url = `User/forgetPassword?username=${this.forgetOTPForm?.value.username}`;
      this.apiDataService.getData(url).subscribe((response: ResponseModel<any>) => {
        if (response.status === HttpStatusCode.OK) {
          this.toastService.showToast(
            Messagetype.sucess,
            'Info',
            `${response.statusMessage}`
          );
          this.isForgetOtpSent = true;
        } else {
          this.toastService.showToast(
            Messagetype.fail,
            '',`${response.statusMessage}`
          );
        }
      });
    }


  ///------------------- OTP form focus for forget otp---------------

  focusForgetInputLogin(e: any, id: any) {
    if (
      (e.keyCode >= 48 && e.keyCode <= 57) ||
      (e.keyCode >= 96 && e.keyCode <= 105)
    ) {
      // 0-9 only

      if (+id < 4) {
        if (
          (<HTMLInputElement>document.getElementById(`forgetlogininput${+id + 1}`))
            .value !== null
        ) {
          document.getElementById(`forgetlogininput${+id + 1}`)?.focus();
        } else {
          document.getElementById(`forgetlogininput${id}`)?.focus();
        }
      }
    }

    if (e.keyCode === 8) {
      if (+id === 1) {
        document.getElementById(`logininput${id}`)?.focus();
      } else {
        document.getElementById(`logininput${+id - 1}`)?.focus();
      }
    }
  }

  getOtp() {
    this.otp = `${this.OTPForm?.value.input1}${this.OTPForm?.value.input2}${this.OTPForm?.value.input3}${this.OTPForm?.value.input4}`;
    return this.otp.trim();
  }

  setForgetPassword() {
    const data = {
      username: this.forgetOTPForm.value.username,
      newPassword: this.forgetOTPForm.value.newPassword,
      otp: this.getOtp(),
      loginfrom: 1,
    };

    const url = `User/setpassLogin`;
    this.apiDataService.postData(url, data).subscribe(
      (response: ResponseModel<any>) => {
        if (response.status === HttpStatusCode.OK) {
            this.toastService.showToast(
            Messagetype.sucess,
            'Info',
            `${response.statusMessage}`
          );
          this.router.navigate(['/home']).then(() => {
            location.href = '/home';
          });
          this.getSetService.SetUser(response.data);
          this.appService.setCurrentUserInfo(response.data);
          // this.toastService.showToast(
          //   Messagetype.sucess,
          //   'Info',
          //   `${response.statusMessage}`
          // );
          document
            .getElementById('login-area')
            ?.classList.remove('open-form');
          this.appService.setUserLogin(true);
          this.OTPForm?.reset();
        } else if (response.status === HttpStatusCode.BAD_REQUEST) {
          this.OTPForm?.reset();

          this.toastService.showToast(
            Messagetype.fail,
            'Info',
            `${response.statusMessage}`
          );
        } else {
          // this.snackBar.open(`${response.statusMessage}`, '×', {
          //   panelClass: 'error',
          //   verticalPosition: 'top',
          //   duration: 3000,
          // });
        }
      }
    )
  }


   // hide : boolean = true;

myFunction() {
  this.hide = !this.hide;
}

//-----------------------------ForgetPassword -----Start----------------------------------------------

getOtpForforgetPassword() {
  if (this.otpform?.valid) {
    const url = `User/forgetPassword?username=${this.otpform.value.otpinput}`;
    this.apiDataService
      .getData(url)
      .subscribe((response: ResponseModel<any>) => {
        if (response.status === HttpStatusCode.OK) {
          // this.snackBar.open(
          //   `Verification code sent to your ${this.otpform.value.otpinput}`,
          //   '×',
          //   {
          //     panelClass: 'success',
          //     verticalPosition: 'top',
          //     duration: 3000,
          //   }
          // );
        } else if (
          response.status === HttpStatusCode.BAD_REQUEST ||
          response.status === HttpStatusCode.INTERNAL_SERVER_ERROR
        ) {
          // this.snackBar.open(`${response.statusMessage}`, '×', {
          //   panelClass: 'error',
          //   verticalPosition: 'top',
          //   duration: 3000,
          // });
        } else {
          // this.snackBar.open(`${response.statusMessage}`, '×', {
          //   panelClass: 'error',
          //   verticalPosition: 'top',
          //   duration: 3000,
          // });
        }
      });
  }
}

  // ---------------------------------verify Login OTP----------------------------------

  public verifyLoginOTP(): void {
    const data = {
      userName: this.loginForm?.value.userName,
      otp: this.getOtp(),
      loginFrom: 1,
    };

    const url = `User/verifyLoginOtp`;
    this.apiDataService
      .postData(url, data)
      .subscribe((response: ResponseModel<any>) => {
        if (response.status === HttpStatusCode.OK) {
          this.toastService.showToast(
            Messagetype.sucess,
            'Info',
            `${response.statusMessage}`
          );
          this.router.navigate(['/home']).then(() => {
            location.href = '/home';
          });
          if (localStorage.getItem('area') != null) {
          }
          this.getSetService.SetUser(response.data);
          this.appService.setCurrentUserInfo(response.data);
          document.getElementById('login-area')?.classList.remove('open-form');
          this.appService.setUserLogin(true);
        } else if (response.status === HttpStatusCode.BAD_REQUEST) {
          this.OTPForm?.reset();
          this.toastService.showToast(
            Messagetype.fail,
            'Info',
            `${response.statusMessage}`
          );
        } else {
          this.toastService.showToast(
            Messagetype.fail,
            'Info',
            `${response.statusMessage}`
          );
        }
      });
  }

    //-----------------------------login with OTP -----Start----------------------------------------------

    public getOTPforLogin(): void {
      this.submitted = true;
      this.loginForm?.controls.password.setValidators(null);
      this.loginForm?.controls.password.setErrors(null);
      this.loginForm?.controls.password.disable();
      // if (this.loginForm?.controls.username.valid) {
        const url = `User/loginwithOtp?userName=${this.loginForm.value.userName}`;
        this.apiDataService
          .getData(url)
          .subscribe((response: ResponseModel<any>) => {
            if (response.status === HttpStatusCode.OK) {
              this.toastService.showToast(
                Messagetype.sucess,
                'Info',
                `${response.statusMessage}`
              );
              this.showverifyOtpFormLogin = true;
              this.isShowLoginForm = false;

              //   this.openOTPdialogForLogin(this.loginForm.value.username);
            } else if (
              response.status === HttpStatusCode.BAD_REQUEST ||
              response.status === HttpStatusCode.INTERNAL_SERVER_ERROR
            ) {
              this.toastService.showToast(
                Messagetype.fail,
                'Info',
                `${response.statusMessage}`
              );
            } else {
              // this.toastService.showToast(
              //   Messagetype.fail,
              //   'Info',
              //   `${response.statusMessage}`
              // );
            }
          });
      // }
    }

     //----------------- OTP form focus input for registration

  focusInputLogin(e: any, id: any) {
    if (
      (e.keyCode >= 48 && e.keyCode <= 57) ||
      (e.keyCode >= 96 && e.keyCode <= 105)
    ) {
      // 0-9 only

      if (+id < 4) {
        if (
          (<HTMLInputElement>document.getElementById(`logininput${+id + 1}`))
            .value !== null
        ) {
          document.getElementById(`logininput${+id + 1}`)?.focus();
        } else {
          document.getElementById(`logininput${id}`)?.focus();
        }
      }
    }

    if (e.keyCode === 8) {
      if (+id === 1) {
        document.getElementById(`logininput${id}`)?.focus();
      } else {
        document.getElementById(`logininput${+id - 1}`)?.focus();
      }
    }

    if (this.getOtp().length === 4) {
      this.verifyLoginOTP();
    }
  }


  // OTP Limit the input to a single digit
  restrictInput(event: any) {
    const inputValue = event.target.value;

    // Remove any non-numeric characters (if any)
    const numericValue = inputValue.replace(/[^0-9]/g, '');

    // Limit the input to a single digit
    if (numericValue.length > 1) {
      event.target.value = numericValue.substring(0, 1);
    }
  }

  //Login With OTP
  public resendOtp(): void {

    this.OTPForm.controls.input1.reset();
    this.OTPForm.controls.input2.reset();
    this.OTPForm.controls.input3.reset();
    this.OTPForm.controls.input4.reset();

    const userName = this.loginForm.controls.userName.value;
//this.loginForm?.value.userName
    const url = `User/loginwithOtp?userName=${userName}`;
    this.apiDataService.getData(url).subscribe((response: ResponseModel<any>) => {
      if (response.status === HttpStatusCode.OK) {
        this.toastService.showToast(
          Messagetype.sucess,
          'Info',
          `${response.statusMessage}`
        );
      } else if (
        response.status === HttpStatusCode.BAD_REQUEST ||
        response.status === HttpStatusCode.INTERNAL_SERVER_ERROR
      ) {
        this.toastService.showToast(
          Messagetype.fail,
          'danger',
          `${response.statusMessage}`
        );
      } else {
        this.toastService.showToast(
          Messagetype.fail,
          'danger',
          `${response.statusMessage}`
        );
      }
    });
  }
  // --------------------------------------------------------------------------------


  get f() {
    return this.loginForm.controls;
  }

  get fp() {
    return this.forgetOTPForm.controls;
  }

    // For hide show password
    showPassword() {
      this.hide = !this.hide;
    }

}
